import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/di/container';
import { QUERY_KEYS } from '@shared/constants';

export const useSearch = (workspaceId: string | undefined, query: string) => {
  const trimmed = query.trim();

  return useQuery({
    queryKey: QUERY_KEYS.search(workspaceId ?? '', trimmed),
    queryFn: () => container.search.search(workspaceId as string, trimmed),
    enabled: Boolean(workspaceId) && trimmed.length > 0,
  });
};
